import React, { useState } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import "../../assets/css/Useraccount.css";
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { LiaUserTieSolid } from "react-icons/lia";
import { GiTwoCoins } from "react-icons/gi";
import { BsCreditCard, BsTicketPerforated } from "react-icons/bs";
import { LuLogOut, LuFolderHeart } from "react-icons/lu";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { IoReceiptOutline } from "react-icons/io5";
import { useAuth } from "../../context/AuthContext";
import nouser from "../../assets/images/no_user.png";
import { Sidebar } from "primereact/sidebar";
import { LuHistory } from "react-icons/lu";
import { MdOutlineFileDownload } from "react-icons/md";
import { MdRoomPreferences } from "react-icons/md";
import { MdLocalOffer } from "react-icons/md";
import {
  TbDice,
} from "react-icons/tb";
const Dashboard = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const { logout, username, userId, tierlevel, balance, creditlimit, imgUrl } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("profile");
  const [openMenu, setOpenMenu] = useState(null);
  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleLogout = () => {
    logout();          // clears auth + disconnects socket (as per your context)
    navigate("/");     // redirect to home / landing page
  };

  const getTierName = (tierlevel) => {
    switch (tierlevel) {
      case 0:
        return "Free";
      case 1:
        return "Basic";
      case 2:
        return "Premium";
      case 3:
        return "Premium+";
      case 4:
        return "Pro";
      default:
        return "Free"; // fallback safety
    }
  };

  const tierName = getTierName(tierlevel);

  const isActive = (path) =>
    location.pathname.startsWith(path);


  /*-----------------userdash_menu--------------*/

  const MenuContent = (
    <div className="right_menupanal">
      <Card className="mb-4 bg-transparent border-0">
        <Card.Body>
          <div className="propart">
            <div className="image_part">
              <Avatar image={imgUrl || nouser} size="xlarge" shape="circle" />
              <Badge value={tierName} severity="warning" />
            </div>

            <h6>{username}</h6>

            <p className="coinvalue">
              <span className="me-2" style={{ color: "#FFADD8" }}>
                <GiTwoCoins />
              </span>
              <span>{balance}</span>
            </p>
          </div>
        </Card.Body>
      </Card>

      <Card className="bg-transparent border-0 p-0">
        <Card.Body className="p-0">
          <ul className="menu-list">

            <li
              className={isActive("/dashboard/profile") ? "active" : ""}
              onClick={() => navigate("/dashboard/profile")}
            >
              <LiaUserTieSolid /> My Profile
            </li>

            {/* <li
              className={isActive("/dashboard/credit-transactions") ? "active" : ""}
              onClick={() => navigate("/dashboard/credit-transactions")}
            >
              <GiTwoCoins /> Credit Transactions
            </li> */}

            <li
              className={isActive("/dashboard/subscriptions") ? "active" : ""}
              onClick={() => navigate("/dashboard/subscriptions")}
            >
              <BsCreditCard /> Subscriptions
            </li>
            <li
              className={isActive("/dashboard/spin-wheel") ? "active" : ""}
              onClick={() => navigate("/dashboard/spin-wheel")}
            >
              <TbDice   /> Lucky Wheel
            </li>
            {/* <li
              className={isActive("/dashboard/offers") ? "active" : ""}
              onClick={() => navigate("/dashboard/offers")}
            >
              <MdLocalOffer /> Offers
            </li> */}
            {/* HISTORY MENU */}
            <li className={openMenu === "history" ? "open" : ""}>
              <div onClick={() => toggleMenu("history")} className="menu-parent">
                <LuHistory /> History
              </div>

              {openMenu === "history" && (
                <ul className="submenu ps-3">

                  <li
                    className={isActive("/dashboard/downloads") ? "active" : ""}
                    onClick={() => navigate("/dashboard/downloads")}
                  >
                    <MdOutlineFileDownload /> Download
                  </li>

                  <li
                    className={isActive("/dashboard/favorites") ? "active" : ""}
                    onClick={() => navigate("/dashboard/favorites")}
                  >
                    <LuFolderHeart /> My Favorites
                  </li>

                  <li
                    className={isActive("/dashboard/credit-transactions") ? "active" : ""}
                    onClick={() => navigate("/dashboard/credit-transactions")}
                  >
                    <GiTwoCoins /> Credit Transactions
                  </li>

                </ul>
              )}
            </li>

            {/* <li
              className={isActive("/dashboard/favorites") ? "active" : ""}
              onClick={() => navigate("/dashboard/favorites")}
            >
              <LuFolderHeart /> My Favorites
            </li> */}

            <li
              className={isActive("/dashboard/billing") ? "active" : ""}
              onClick={() => navigate("/dashboard/billing")}
            >
              <IoReceiptOutline /> Billing
            </li>

            <li
              className={isActive("/dashboard/preference") ? "active" : ""}
              onClick={() => navigate("/dashboard/preference")}
            >
              <MdRoomPreferences /> Preference
            </li>
            <li
              className={isActive("/dashboard/raise-ticket") ? "active" : ""}
              onClick={() => navigate("/dashboard/raise-ticket")}
            >
              <BsTicketPerforated /> Raise Ticket
            </li>

            <li onClick={handleLogout}>
              <LuLogOut /> Logout
            </li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );

  return (
    <>
      <Container fluid className="p-0">
        {/* <Row className="mx-0 breadcrumb_part">
          <h3>Welcome! {username}</h3>
        </Row> */}

        <Row className="mx-0 p-0 user-dashboard">
          {/* LEFT MENU */}
          <Col md={3} className="d-none d-lg-block right_menupanal">
            {MenuContent}
          </Col>

          {/* RIGHT CONTENT CARDS */}
          <Col md={9} className="overflow-hidden left-menupanal">
            <div className="mobile-menu-btn">
              <Button
                icon="pi pi-ellipsis-v"
                onClick={() => setMenuVisible(true)}
                text
                tooltip="More"
                tooltipOptions={{ position: "left" }}
              />
            </div>
            <Card className={`Profilecard fade-card show`}>
              <Card.Body>
                <Outlet />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* MOBILE SIDEBAR */}
      <Sidebar visible={menuVisible} onHide={() => setMenuVisible(false)} position="right">
        {MenuContent}
      </Sidebar>
    </>
  );
};

export default Dashboard;
